import { Component, OnInit, Inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from "@angular/material/dialog";
import { HelperService } from "src/app/servicios/helper.service";
import Swal from "sweetalert2/dist/sweetalert2.all.js"; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TipoFrecuenciaService } from "src/app/servicios/tipo-frecuencia.service";
import { RuteroDiasSemanaService } from "src/app/servicios/rutero-dias-semana.service";
import { TipoRuteroService } from "src/app/servicios/tipo-rutero.service";

import * as _moment from "moment";
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { RuteroService } from "src/app/servicios/rutero.service";
import { MatSnackBar } from "@angular/material/snack-bar";

export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY-MM-DD"
  },
  display: {
    dateInput: "YYYY-MM-DD",
    monthYearLabel: "YYYY-MM-DD",
    dateA11yLabel: "YYYY-MM-DD",
    monthYearA11yLabel: "YYYY-MM-DD"
  }
};

@Component({
  selector: "app-dialog-rutero",
  templateUrl: "./dialog-rutero.component.html",
  styleUrls: ["./dialog-rutero.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class DialogRuteroComponent implements OnInit {
  configuracionForm: FormGroup;
  frecuenciaForm: FormGroup;
  frecuenciasSelectForm: FormGroup;
  diasForm: FormGroup;

  origen = "";
  idSucursal = 0;
  idUsuario = 0;
  idUsuarioCrea = 0;
  ruteroSucursal = [];
  frecuenciaSeleccionada = [];

  loadingTiposFrecuencia = false;
  dataModified=false;

  editandoRuteroSucursal = false;

  tiposRutero = [];
  loadingTiposRutero = false;

  frecuencias = [];
  loadingFrecuencia = [];
  diasSemana = [];

  tipoRuteroVal = 0;

  frecuenciasArray = [];

  order: string = "id";

  frecuenciaActual = 0;
  mostrarDias = false;

  dataRuteroEditado = {
    estado: "error",
    idUsuario: 0
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    public dialogRef: MatDialogRef<DialogRuteroComponent>,
    private dialog: MatDialog,
    private _helper: HelperService,
    private fb: FormBuilder,
    private servicioFrecuencia: TipoFrecuenciaService,
    private servicioDiaSemana: RuteroDiasSemanaService,
    private servicioTiposRutero: TipoRuteroService,
    private servicioRutero: RuteroService,
    private snackBar: MatSnackBar
  ) {
    this.configuracionForm = this.fb.group({
      tipoRutero: ["", Validators.required]
    });

    this.frecuenciaForm = this.fb.group({
      tipoFrecuencia: ["", Validators.required],
      fechaFrecuencia: [new Date()]
    });

    this.frecuenciasSelectForm = this.fb.group({
      frecuenciaSelect: ["", Validators.required]
    });

    this.diasForm = this.fb.group({
      diasVisita: ["", Validators.required]
    });

    //console.log(JSON.stringify(dataDialog));
    this.origen = dataDialog.origen;
    this.idSucursal = dataDialog.idSucursal;
    this.idUsuario = dataDialog.idUsuario;
    this.idUsuarioCrea = dataDialog.idUsuarioCrea;

    this.servicioTiposRutero.getTiposRutero().subscribe(result => {
      this.tiposRutero = result;
    });

    this.servicioDiaSemana.getRuteroDiasSemana().subscribe(result => {
      this.diasSemana = result;
    });

    if (this.origen == "editar") {
      this.ruteroSucursal = dataDialog.ruteroSucursal;
      const tipoRutero = this._helper.uniq(
        this.ruteroSucursal,
        "ruteroTipoRutero"
      );

      if (tipoRutero[0].tipoRutero == 1) {
        const frecuenciasRutero = this._helper.uniq(
          this.ruteroSucursal,
          "ruteroFrecuencias"
        );
        //const diasRutero = this._helper.uniq(this.ruteroSucursal, 'ruteroDias');

        let frecuenciasArrayLocal = [];

        frecuenciasRutero.forEach(element => {
          frecuenciasArrayLocal.push(element.idTpoFrecuencia);
        });

        //console.log(frecuenciasArrayLocal);

        if (tipoRutero.length > 1) {
          Swal.fire(
            "Creación De Rutero!",
            "Verifique que todas las frecuencias tengan dias asignados.",
            "error"
          );
          dialogRef.close(this.dataRuteroEditado);
          return;
        }

        this.servicioFrecuencia
          .getTiposFrecuencia(tipoRutero[0].tipoRutero)
          .subscribe(result => {
            this.frecuencias = result;
            let frecuenciasCliente = [];
            //frecuenciasArray=frecuenciasArray.sort();
            frecuenciasArrayLocal.forEach(element => {
              let item = this._helper.where(this.frecuencias, { id: element });
              frecuenciasCliente.push(item[0]);
            });

            this.frecuenciaSeleccionada = frecuenciasCliente;
          });

        this.tipoRuteroVal = tipoRutero[0].tipoRutero;
        this.configuracionForm.controls["tipoRutero"].setValue(
          tipoRutero[0].tipoRutero
        );
        this.frecuenciaForm.controls["tipoFrecuencia"].setValue(
          frecuenciasArrayLocal
        );

        console.log(JSON.stringify(frecuenciasArrayLocal));

        if (this.tipoRuteroVal == 1 && this.origen == "editar") {
          frecuenciasArrayLocal.forEach(element => {
            let frecuenciaIteracion = element;
            let diasVisitaInternoArray = [];
            const diasArrayFrecuencia = this._helper.where(
              this.ruteroSucursal,
              { idTpoFrecuencia: element }
            );
            diasArrayFrecuencia.forEach((element: any) => {
              diasVisitaInternoArray.push(element.idDiaSemana);
            });
            this.frecuenciasArray.push({
              idTipoFrecuencia: frecuenciaIteracion,
              idTipoRutero: this.tipoRuteroVal,
              fechaVisita: "",
              diasVisita: diasVisitaInternoArray
            });
          });
        }
      } //end tiporutero = 1
      else if (tipoRutero[0].tipoRutero == 2) {
        this.configuracionForm.controls["tipoRutero"].setValue(
          tipoRutero[0].tipoRutero
        );
        this.tipoRuteroVal=tipoRutero[0].tipoRutero;
        const fechaVisita = this.ruteroSucursal[0].fechaVisita;
        this.frecuenciaForm.controls['fechaFrecuencia'].setValue(fechaVisita);
        console.log(JSON.stringify(this.ruteroSucursal));
      }
    } //end editar

    //this.frecuenciasSelectForm.controls['frecuenciaSelect'].setValue(frecuenciasArray);
  }

  ngOnInit() {}

  setTipoRutero() {
    this.tipoRuteroVal = this.configuracionForm.controls["tipoRutero"].value;
    if (this.tipoRuteroVal == 2) {
      this.mostrarDias = false;
    }
    this.loadingTiposFrecuencia = true;
    this.servicioFrecuencia
      .getTiposFrecuencia(this.tipoRuteroVal)
      .subscribe(result => {
        this.frecuencias = result;
        this.loadingTiposFrecuencia = false;
      });
  }

  selectFrecuencia(event) {
    if (event.isUserInput) {
      //console.log(event.source.value, event.source.selected);
      if (event.source.selected) {
        const frecuenciaWhere = this._helper.where(this.frecuencias, {
          id: event.source.value
        });
        const frecuenciaData: any = frecuenciaWhere;
        //console.log(frecuenciaData[0].id);

        this.frecuenciaSeleccionada.push(frecuenciaData[0]);
      } else {
        let index = this._helper.findIndex(this.frecuenciaSeleccionada, {
          id: event.source.value
        });
        let index1 = this._helper.findIndex(this.frecuenciasArray, {
          idTipoFrecuencia: event.source.value
        });
        if (index > -1) {
          this.frecuenciaSeleccionada.splice(index, 1);
        }

        if (index1 > -1) {
          this.frecuenciasArray.splice(index, 1);
        }
      }
    }
  }

  selectFecha(event) {
    const fecha = _moment(
      this.frecuenciaForm.get("fechaFrecuencia").value,
      "YYYY-MM-DD"
    ).format("YYYY-MM-DD");
    this.frecuenciasArray = [];
    this.frecuenciasArray.push({
      idTipoFrecuencia: 1,
      idTipoRutero: this.configuracionForm.controls["tipoRutero"].value,
      fechaVisita: fecha,
      diasVisita: []
    });
  }

  handleSelection(event) {
    //console.log(event.source.options._results);
    //return;
    /*if (event.option.selected) {
      //console.log(event.option.value);
      event.source.options._results.forEach((element, index) => {
        console.log(element._value, event.option.value);
        if (element._value != event.option.value) {
          //element._selected = false;
          event.source.options._results[index]._selected=false;
        }
      });
    }*/
    if (event.option.selected) {
      event.source.deselectAll();
      event.option._setSelected(true);
      this.frecuenciaActual = event.option.value;
      this.mostrarDias = true;

      //console.log(this.frecuenciaActual);

      const frecuenciaWhere = this._helper.where(this.frecuenciasArray, {
        idTipoFrecuencia: this.frecuenciaActual
      });
      //console.log(frecuenciaWhere.length);
      if (frecuenciaWhere.length == 0) {
        //no existe en frecuenciasArray no pasa nada
        this.diasSemana.forEach(element => {
          element.checked = false;
        });
        this.diasForm.controls["diasVisita"].setValue([]);

        if (this.origen == "editar") {
          //si viene de la opcion de editar debo setear los dias visita con los que estan seleccionados
          const ruteroFrecuencia = this._helper.where(this.ruteroSucursal, {
            idTpoFrecuencia: this.frecuenciaActual
          });
          //let existenFrecuencia=0;
          if (ruteroFrecuencia.length > 0) {
            //existe la frecuencia seleccionado en el rutero Sucursal
            const diasVisitaArray = [];
            ruteroFrecuencia.forEach((element: any) => {
              diasVisitaArray.push(element.idDiaSemana);
            });

            this.frecuenciasArray.push({
              idTipoFrecuencia: this.frecuenciaActual,
              idTipoRutero: this.configuracionForm.controls["tipoRutero"].value,
              fechaVisita: "",
              diasVisita: diasVisitaArray
            });
            this.diasForm.controls["diasVisita"].setValue(diasVisitaArray);
          } else {
            this.frecuenciasArray.push({
              idTipoFrecuencia: this.frecuenciaActual,
              idTipoRutero: this.configuracionForm.controls["tipoRutero"].value,
              fechaVisita: "",
              diasVisita: []
            });
          }
        } else {
          this.frecuenciasArray.push({
            idTipoFrecuencia: this.frecuenciaActual,
            idTipoRutero: this.configuracionForm.controls["tipoRutero"].value,
            fechaVisita: "",
            diasVisita: []
          });
        }
      } else {
        //ya existe debo parsear con el arreglo de dias

        const frecuenciaWhere = this._helper.where(this.frecuenciasArray, {
          idTipoFrecuencia: event.option.value
        });

        this.diasSemana.forEach(element => {
          element.checked = false;
        });
        const dias: any = frecuenciaWhere;
        //console.log(event.option.value);
        //return;
        this.diasForm.controls["diasVisita"].setValue(dias[0].diasVisita);
        dias[0].diasVisita.forEach(element => {
          let index = this._helper.findIndex(this.diasSemana, {
            id: element
          });
          this.diasSemana[index].checked = true;
        });
        //console.log(this.frecuenciasArray);
      }
    }
  }

  setDiasFrecuencia() {
    //console.log(JSON.stringify(this.frecuenciasArray));
    //return;
    const diasSelected = this.diasForm.controls["diasVisita"].value;
    let index = this._helper.findIndex(this.frecuenciasArray, {
      idTipoFrecuencia: this.frecuenciaActual
    });
    this.frecuenciasArray[index].diasVisita = diasSelected;

    //console.log('ok');
    //console.log(JSON.stringify(this.frecuenciasArray));
    //console.log(diasSelected);
  }

  editarRuteroSucursal() {
    const tipoRutero = this.configuracionForm.controls["tipoRutero"].value;
    let ruteroSucursalEditado: any;
    if (tipoRutero == 1) {
      ruteroSucursalEditado = {
        idUsuario: this.idUsuario,
        usuarioCrea: this.idUsuarioCrea,
        clientes: [
          {
            idCliente: this.idSucursal,
            frecuencias: this.frecuenciasArray
          }
        ]
      };
    } else {
      const fecha = _moment(
        this.frecuenciaForm.get("fechaFrecuencia").value,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      ruteroSucursalEditado = {
        idUsuario: this.idUsuario,
        usuarioCrea: this.idUsuarioCrea,
        clientes: [
          {
            idCliente: this.idSucursal,
            frecuencias: [
              {
                idTipoFrecuencia: 1,
                idTipoRutero: this.configuracionForm.controls["tipoRutero"]
                  .value,
                fechaVisita: fecha,
                diasVisita: []
              }
            ]
          }
        ]
      };
    }
    //console.log(JSON.stringify(ruteroSucursalEditado));

    //return;

    if (ruteroSucursalEditado.clientes[0].frecuencias.length == 0) {
      this.dialogRef.close(this.dataRuteroEditado);
      return;
    }

    this.editandoRuteroSucursal = true;
    this.servicioRutero.putRutero(ruteroSucursalEditado).subscribe(result => {
      this.snackBar.open("Rutero", "Rutero Actualizado Satisfactoriamente", {
        duration: 3000
      });
      this.editandoRuteroSucursal = false;
      this.dataRuteroEditado.estado = "ok";
      this.dataRuteroEditado.idUsuario = this.idUsuario;
      this.dialogRef.close(this.dataRuteroEditado);
    });

    //console.log(JSON.stringify(ruteroSucursalEditado));
  }

  crearRuteroSucursal() {
    const tipoRutero = this.configuracionForm.controls["tipoRutero"].value;
    let ruteroSucursalEditado: any;
    //console.log(JSON.stringify(this.frecuenciasArray));
    if (tipoRutero == 1) {
      ruteroSucursalEditado = {
        idUsuario: this.idUsuario,
        usuarioCrea: this.idUsuarioCrea,
        clientes: [
          {
            idCliente: this.idSucursal,
            frecuencias: this.frecuenciasArray
          }
        ]
      };
    } else {
      const fecha = _moment(
        this.frecuenciaForm.get("fechaFrecuencia").value,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      ruteroSucursalEditado = {
        idUsuario: this.idUsuario,
        usuarioCrea: this.idUsuarioCrea,
        clientes: [
          {
            idCliente: this.idSucursal,
            frecuencias: [
              {
                idTipoFrecuencia: 1,
                idTipoRutero: this.configuracionForm.controls["tipoRutero"]
                  .value,
                fechaVisita: fecha,
                diasVisita: []
              }
            ]
          }
        ]
      };
    }
    //console.log(JSON.stringify(ruteroSucursalEditado));

    //return;

    if (ruteroSucursalEditado.clientes[0].frecuencias.length == 0) {
      this.dialogRef.close(this.dataRuteroEditado);
      return;
    }

    this.editandoRuteroSucursal = true;
    this.servicioRutero.putRutero(ruteroSucursalEditado).subscribe(result => {
      this.snackBar.open("Rutero", "Rutero Creado Satisfactoriamente", {
        duration: 3000
      });
      this.editandoRuteroSucursal = false;
      this.dataRuteroEditado.estado = "ok";
      this.dataRuteroEditado.idUsuario = this.idUsuario;
      this.dialogRef.close(this.dataRuteroEditado);
    });

    //console.log(JSON.stringify(ruteroSucursalEditado));
  }
}
